import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const templatesSlice = createSlice({
    name: "templates",
    initialState,
    reducers: {
        fetchTemplatesRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchTemplatesSuccess: (state, action) => {
            state.loading = false;
            state.data = action.payload;
        },
        fetchTemplatesFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { fetchTemplatesRequest, fetchTemplatesSuccess, fetchTemplatesFailure } = templatesSlice.actions;

export default templatesSlice.reducer;
